const organizationEnglish = {
  common: {
    loading: "Loading...",
    error: "An error occurred",
    save: "Save",
    cancel: "Cancel",
    yes: "Yes",
    no: "No"
  },
  header: {
    title: "Organization",
    adminRole: "Administrator",
    employeeRole: "Employee",
    adminDescription: "Manage your organization, team members and customer assignments",
    employeeDescription: "View your organization, team members and customer assignments"
  },
  messages: {
    confirmRemoveMember: "Are you sure you want to remove {email} from the organization?",
    confirmCancelInvitation: "Are you sure you want to cancel this invitation?",
    confirmCancelSubscription: "Are you sure you want to cancel this subscription?"
  },
  notifications: {
    success: {
      invitationSent: "Invitation sent to {email}",
      memberRemoved: "Member removed from organization",
      invitationCancelled: "Invitation cancelled",
      customerAssigned: "Customer assigned to employee",
      assignmentRemoved: "Customer assignment removed",
      licenseAdded: "Licenses added"
    },
    error: {
      general: "An error occurred",
      emailRequired: "Please enter an email",
      noOrganization: "No organization found",
      memberExists: "This user is already a member of the organization",
      invitationExists: "This user has already been invited to the organization",
      billingPortal: "An error occurred while opening the customer portal. Please try again later."
    }
  },
  subscription: {
    card: {
      title: "LinkedIn Poster Licenses",
      status: {
        active: "Active",
        trialing: "Trial",
        inactive: "Inactive"
      },
      currentPlan: "Current plan:",
      noPlan: "No plan",
      licenseInfo: {
        total: "Total licenses",
        assigned: "Assigned licenses",
        available: "Available licenses"
      },
      trial: {
        info: "Your trial expires on"
      },
      actions: {
        addLicenses: "Add licenses",
        manageBilling: "Manage billing"
      }
    }
  },
  team: {
    card: {
      title: "Team",
      inviteButton: "Invite member",
      emptyState: {
        admin: "Your team is empty. Invite team members by clicking the \"Invite member\" button.",
        employee: "There are no team members in the organization yet."
      },
      memberInfo: {
        you: "(You)",
        admin: "Administrator",
        member: "Member",
        status: {
          active: "Active",
          invited: "Invited"
        },
        invitationBadge: "Invitation"
      }
    }
  },
  customerManagement: {
    card: {
      title: "Customer Management",
      adminSubheader: "Assign customers to employees",
      employeeSubheader: "View customers and assignments",
      emptyState: {
        admin: "There are no customers in the organization yet. Invite customers by selecting \"Customer\" in the invitation form.",
        employee: "There are no customers in the organization yet."
      },
      tableHeaders: {
        customer: "Customer",
        email: "Email",
        status: "Status",
        assignedTo: "Assigned to",
        actions: "Actions"
      },
      status: {
        active: "Active",
        invited: "Invited"
      },
      notAssigned: "Not assigned",
      actions: {
        assign: "Assign customer",
        removeAssignment: "Remove assignment"
      }
    }
  },
  modals: {
    assignLicense: {
      title: "Assign License",
      email: "Email",
      licenseType: "License type",
      availableLicenses: "Available licenses:",
      licenseTypes: {
        basic: "Basic",
        pro: "Professional",
        enterprise: "Enterprise"
      }
    },
    updateSubscription: {
      title: "Update Subscription",
      quantity: "Number of licenses",
      preview: {
        plan: "Plan:",
        pricePerLicense: "Price per license:",
        total: "Total:"
      }
    },
    inviteMember: {
      title: "Invite Team Member",
      email: "Email",
      emailPlaceholder: "Enter team member's email",
      role: "Role",
      roles: {
        employee: "Employee (Can manage own and others' profiles)",
        customer: "Customer (Can only login with LinkedIn)"
      },
      info: "An invitation will be sent to this email. When the user accepts the invitation, they will be assigned a license.",
      employeeInfo: " As an employee, they can manage both their own and others' LinkedIn profiles.",
      customerInfo: " As a customer, they can only login with LinkedIn and will not have access to the dashboard.",
      availableLicenses: "Available licenses:",
      sending: "Sending invitation...",
      send: "Send invitation"
    },
    buyLicense: {
      title: "Buy more licenses",
      info: "You need to purchase more licenses to invite more members. You currently have {currentLicenses} license(s).",
      quantity: "Number of licenses to add",
      pricing: {
        info: "Each license gives one seat to a team member",
        price: "Price: 1490 DKK excl. VAT/month per license (There is a possibility to enter a discount code)",
        total: "Total: {total} DKK excl. VAT/month"
      },
      buy: "Buy licenses"
    },
    assignCustomer: {
      title: "Assign Customer: {customerName}",
      selectEmployee: "Select employee",
      noEmployee: "Select employee",
      assign: "Assign Customer"
    }
  }
};

export default organizationEnglish; 